module.exports = "<!--\r\n    <div *ngIf=\"mainConfiguration.ShowPrice && minorDigits.length > 0\" (click)=\"showDetails()\" class=\"price-bage\" [class.hide]=\"!isShown || !isFited\">\r\n        <ul>\r\n            <li class=\"digit\" *ngFor=\"let digit of majorDigits\">{{digit}}</li>\r\n            <li *ngIf=\"majorDigits.length > 0\" class=\"point\">.</li>\r\n            <li class=\"digit\" *ngFor=\"let digit of minorDigits\">{{digit}}</li>\r\n            <li class=\"point\"> :-</li>\r\n        </ul>\r\n    </div>\r\n-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/price_bage/price_bage.component.html
// module id = 558
// module chunks = 1